import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { WidgetsRounded } from '@mui/icons-material';

type ActionResponse = Array<{ id: string; name: string }>;

export type AndieSearchAvailableWidgetsProps = ActionRenderAi<ActionResponse>;

const AndieSearchAvailableWidgets = (props: AndieSearchAvailableWidgetsProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.search-available-widgets.title')}
            icon={<WidgetsRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.search-available-widgets.loading')]}
            completeMessage={({ result, args }) =>
                t('andie.tool.search-available-widgets.complete', {
                    query: args?.search ?? '*',
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieSearchAvailableWidgets;
